export const removeClass = (el, className) => {
  if (el.classList) { el.classList.remove(className); } else { el.className = el.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' '); }
};
